export const mapById = <T>(array: T[], key: keyof T) => {
  return array.reduce(
    (acc, next) => ({ ...acc, [next[key] as unknown as string]: next }),
    {}
  );
};
